module.exports = __webpack_public_path__ + "static/media/drawing_lo5d.b2d070e7.mp3";